// Window CustomEvent names used to decouple the HTTP interceptors (no React
// access) from the providers that own session and notice state.
export const APP_EVENTS = Object.freeze({
    SESSION_EXPIRED: 'auth:session-expired',
    PERMISSIONS_REFRESH: 'auth:permissions-refresh',
    NOTICE: 'app:notice',
});
